// import { $ } from "@olmokit/dom";
import "components/Sensitech";
import "components/Mosaic";
import collectionProductsSlider from "./products";
import collectionMosaicSliders from "./mosaics";
import gallery from "components/Gallery";
import { handleProductOpen, handlePopState } from "components/Product";
import { $, on, $all, forEach } from "@olmokit/dom"
import { scrollTo } from "@olmokit/core/scroll/scrollTo";
import { isFunction } from "@olmokit/utils/isFunction";
// import { onScroll } from "@olmokit/core/scroll/onScroll";
import { Storefinder } from "components/Storefinder";
import "components/Trim";
import linkToPlayerInlined from "@olmokit/core/orchestrations/linkToPlayerInlined";
import { globalData } from "@olmokit/core/data";
import ScrollTrigger from '@terwanerik/scrolltrigger'
import { 
  dataLayerDowload, 
  dataLayerPurchase, 
  dataLayerViewItem 
} from "components/Datalayer"
import "components/Card/Mood";
import "./index.scss";
import "./mosaics.scss";

/**
 * Component: PageCollection
 */
export function PageCollection() {
  console.log("PageCollection mounted.");

  const collection = globalData.collection
  const category = collection.property.find((prod) => 'Category' == prod.parent.name)
  const look = collection.property.find((prod) => 'Look' == prod.parent.name)

  dataLayerViewItem(collection.name, collection.name, category.name, look.name)

  on(document, "click", handleProductOpen);
  // on(window, "popstate", handlePopState);

  collectionMosaicSliders()

  collectionProductsSlider()

  gallery('.PageCollection:')

  linkToInlineVideo(".details:resources__video", "#video");
  linkToInlineVideo(".details:resources__video--training", "#video-training");

  const $root = $('.Storefinder:img');
  Storefinder($root).init();

  forEach($all("[download]"), el => {
    on(el, 'click', () => {
      const title = el.getAttribute('download')
      const collection = el.getAttribute('collection')
      const action = el.getAttribute('action')      
      dataLayerDowload(collection, title, action)

      let selectedCategory = globalData.collection.property.find((prod) => 'Category' == prod.parent.name)
      let selectedLook = globalData.collection.property.find((prod) => 'Look' == prod.parent.name)
      const path = title.split('/');
      const fileName = path[path.length - 1]
      dataLayerPurchase(title, selectedCategory.name, selectedLook.name, fileName, 0)
    })
  });  

}


function linkToInlineVideo(
  triggerSelector: string,
  targetSelector: string
) {
  const $trigger = $(triggerSelector);
  if (!$trigger) return;

  const $target = $(targetSelector);
  const getPlayer = () => import("@olmokit/core/player");
  const handleVideoReached = () => {
    getPlayer().then(({ Player }) => {
      Player($(".video-js", $target) as HTMLElement).play();
    });
  };

  on($trigger, "click", (event) => {
    event.preventDefault();

    scrollTo($target, {
      onstop: handleVideoReached,
      speed: 10,
    });
  });

  onScroll($target, {
    onin: getPlayer,
  });
}

/**
 * Normalise options (custom ones merged with ScrollTrigger ones)
 */
export function normaliseInitialiserOptions(
  custom: OnScroll.InitaliserOptions
): OnScroll.Options {
  let options;

  // if given a function as second parameter shortcut to onin callback, and
  // leave defaults settings for the rest
  if (isFunction(custom)) {
    options = { onin: custom };
  } else {
    options = custom || {};
  }

  // with defaults
  let { onin, onout } = options;
  const { onchange, once = true, offset = {}, toggle = {} } = options;

  // onchange will fire both at in and out callbacks
  if (onchange) {
    onin = onchange;
    onout = onchange;
  }

  if (!toggle.callback) toggle.callback = {};

  // @ts-expect-error FIXME: core scroll types
  return { onin, onout, onchange, once, offset, toggle };
}

/**
 * Init an onScroll action/trigger reusing the same listener singleton
 *
 * It can be called with options as second argument or with a function to
 * defaults to `in` callback behaviour
 *
 * @see https://github.com/terwanerik/ScrollTrigger
 *
 * @type {OnScroll.initaliser}
 */
export const onScroll: OnScroll.Initaliser = (target, custom) => {

  const trigger = new ScrollTrigger();

  // @ts-expect-error FIXME: core scroll types
  const { once, offset, toggle, onin, onout } =
    normaliseInitialiserOptions(custom);

  /**
   * Callback called on `in` (just pass the element as argument as the trigger
   * instance is not very much used in real word scenarios)
   */
  function callbackIn(trigger: OnScroll.Trigger) {
    onin?.(trigger.element);
  }

  /**
   * Callback called on `out` (just pass the element as argument as the trigger
   * instance is not very much used in real word scenarios)
   */
  function callbackOut(trigger: OnScroll.Trigger) {
    onout?.(trigger.element);
  }

  // final ScrollTrigger options to treat based on given options
  const opts = {
    once,
    offset,
    toggle,
  };

  if (onin) {
    opts.toggle.callback.in = callbackIn;
  }
  if (onout) {
    opts.toggle.callback.out = callbackOut;
  }

  trigger.add(target, opts);

  return {
    trigger,
    target,
  };
};